import { zero_pad as e } from "../zero-pad/index.js";
import t from "./look-up.js";
import n from "dayjs";
// src/design/forms/datepicker/calendar-carburettor/converter/index.ts
var r = "1943-04-14", i = (e, t) => {
	let n = 0, r = e.length - 1;
	for (; n <= r;) {
		let i = Math.floor((n + r) / 2);
		if (e[i] === t) return i;
		e[i] < t ? n = i + 1 : r = i - 1;
	}
	return e[r] > t ? r : n;
}, a = (a) => {
	let o = n(a).diff(r, "day"), s = Object.keys(t.dataset).map((e) => parseInt(e)), c = Object.values(t.dataset), l = i(s, o), u = o - s[l], d = u < 0 ? o - s[l - 1] : u, f = 1, p = 1;
	for (; d > 0;) {
		let e = c[l].month_days[f];
		p++, p > e && (f++, p = 1), f > 12 && (f = 1), d--;
	}
	return `${u === d ? c[l].year + 1 : c[l].year}-${e(f)}-${e(p)}`;
}, o = (e) => {
	let [i, a, o] = e.split("-"), s = Object.keys(t.dataset).map((e) => parseInt(e)), c = Object.values(t.dataset), l = c.findIndex((e) => e.year === parseInt(i)), u = c[l], d = s[l - 1], f = 1, p = 0;
	for (; f < parseInt(a);) p += u.month_days[f], f++;
	let m = 1;
	for (; m < parseInt(o);) p++, m++;
	let h = d + p;
	return n(r).add(h, "day").format("YYYY-MM-DD");
};
export { a as ad2bs, o as bs2ad };

//# sourceMappingURL=index.js.map